import {ENABLE_ACCESS_CODE_SEND_TO_PCS} from "../_actions/access.code.pcs.actions";

export const INITIAL_STATE = false;

export function enableAccessCodeSendToPCSReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ENABLE_ACCESS_CODE_SEND_TO_PCS: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/access.code.pcs.reducer.js